// extracted by mini-css-extract-plugin
module.exports = {"postCategory":"post-category-module--post-category--10Zbs"};